var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrendUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 3.5V7.5C15.75 7.69891 15.671 7.88968 15.5303 8.03033C15.3897 8.17098 15.1989 8.25 15 8.25C14.8011 8.25 14.6103 8.17098 14.4697 8.03033C14.329 7.88968 14.25 7.69891 14.25 7.5V5.3125L9.53062 10.0325C9.46095 10.1024 9.37815 10.1579 9.28699 10.1958C9.19583 10.2336 9.09809 10.2531 8.99937 10.2531C8.90066 10.2531 8.80292 10.2336 8.71176 10.1958C8.6206 10.1579 8.5378 10.1024 8.46812 10.0325L6.5 8.0625L2.53062 12.0306C2.38973 12.1715 2.19863 12.2507 1.99937 12.2507C1.80012 12.2507 1.60902 12.1715 1.46812 12.0306C1.32723 11.8897 1.24807 11.6986 1.24807 11.4994C1.24807 11.3001 1.32723 11.109 1.46812 10.9681L5.96812 6.46812C6.0378 6.3982 6.1206 6.34273 6.21176 6.30487C6.30292 6.26702 6.40066 6.24753 6.49937 6.24753C6.59808 6.24753 6.69582 6.26702 6.78699 6.30487C6.87815 6.34273 6.96095 6.3982 7.03062 6.46812L9 8.4375L13.1875 4.25H11C10.8011 4.25 10.6103 4.17098 10.4697 4.03033C10.329 3.88968 10.25 3.69891 10.25 3.5C10.25 3.30109 10.329 3.11032 10.4697 2.96967C10.6103 2.82902 10.8011 2.75 11 2.75H15C15.1989 2.75 15.3897 2.82902 15.5303 2.96967C15.671 3.11032 15.75 3.30109 15.75 3.5Z",
    fill: "#2DC26B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendUp);
export default __webpack_public_path__ + "static/media/TrendUp.f96fe5047fa42360b35256e58ecd1096.svg";
export { ForwardRef as ReactComponent };